import { useClient } from '@composables/use-clients';
import {
  PutRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type ReviewAttributeSerializerType = {
  name: string;
};

export type PutReviewAttributeArgsType = PutRequestArgsType<ReviewAttributeSerializerType> & {
  reviewCode: string;
};

export const apiUpdateReviewAttribute = async ({
  domain = useTenantStore().domain,
  reviewCode,
  payload,
  errorConfig = {},
  callbacks = {},
}: PutReviewAttributeArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.reviewAttribute({ domain, reviewCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
